
import React, { FunctionComponent, useCallback, useContext, useEffect, useRef, useState } from 'react';
import {
  Box,
  Breadcrumbs,
  Button,
  Dialog,
  Grid,
  Link,
  ListItemIcon,
  Theme,
  Toolbar,
  Typography,
} from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import { useDispatch } from 'react-redux';
import { Link as RouteLink, useHistory, useParams } from 'react-router-dom';
import { DownloadFile, getDocumentThumb, getFileSuffix, getFileType, isWeiXin, SampleSendEvent, Tenant } from '@ivymobi/orbit-core';
import { DeviceType, WebSiteContext, TenantContext, UserContext, InnerUserContext } from '../orbit-context';
import _, { isEmpty, isNull, pick } from 'lodash';
import { getICatalogDocumentsAction, getOutLibDocumentsAction, userShareEvent } from '@ivymobi/orbit-core/business/share';
import { DocumentGridCard } from '../documents/grid';
import PreviewDialog from '../documents/preview';
import LoginForm from './form/loginForm';
import { getTenantsIsLeadsInfoByphoneAction, getselLeadsInfoByphoneAction } from '@ivymobi/orbit-core/business/stats';
import { loginAction, sendLoginMobileCodeAction } from '@ivymobi/orbit-core/business/user';
import { LeadMustForm } from './form/leadform';
import ShareUrl from '../components/views/shareUrl';
import { v4 as uuid } from 'uuid'; 
import { documentEventAction } from '@ivymobi/orbit-core/business/document';


const useStyles = makeStyles((theme: Theme) => createStyles({
  pages: {
    display: 'flex',
    flexDirection:'column',
    height:'100%',
    alignItems:'center'
  },
  sliderBar:{
    display: 'flex',
    flexDirection:'column',
    width:'25%',
    paddingTop:theme.spacing(6),
    paddingBottom:theme.spacing(2)
  },
  content:{
    flexGrow:1,
    flexBasis:0,
    display:'flex',
    // justifyContent:'center',
    alignItems:'center',
    flexDirection:'column',
    paddingTop:theme.spacing(6),
    paddingBottom:theme.spacing(2)  
  }
}));

const queryParse = (query)=>{
  query = query.substring(query.indexOf('?')+1);
  let array = query.split("&")
  let params = {};
  array.forEach(item => {
    let key = item.substring(0,item.indexOf('='));
    let value= decodeURIComponent(item.substring(item.indexOf('=')+1));
    params[key]= value;
  });
  return params;
}

export const FileDownloadView = (props: any) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const {doLogin,aclInfo:acl} = props;
  const {user, token} = useContext(UserContext);
  const [eventID, setEventID] = useState(null);// 埋点事件创建ID

  const deviceType = useContext(DeviceType);
  const tenant = useContext(TenantContext);

  const { id,root } = useParams<any>() ?? {id: null,root:null};
  const params = queryParse(location.search);

  const [useLoading, setUseLoading] = useState(false);
  const [documents, setDocuments] = useState({});
  const [{documentId, _bak_id, documentType}, setInfo] = useState({documentId: null, _bak_id: null, documentType: null});
  const [mustShow, setMustShow] = useState(false);
  const [leadProfile, setLeadProfile] = useState({});
  const [routers, setRouters] = useState([]);
  const [selectDoc, setSelectDoc] = useState(null);

  const [data, setData] = useState([])
  const [firstDocs, setFirstDocs] = useState([])
  const [isLogining, setIsLogining] = useState(false);
  const innerUser = useContext(InnerUserContext);
  console.log("user======",user)
  const findPath = (dispatch, path, documents) => {
    const [docId] = path;
    const doc = documents[docId];

    if (!doc) {
      dispatch(getICatalogDocumentsAction({ tenantId: tenant?.id, id: docId })).then(res => {
        let children = res[0]?.children??res;

        let current = {};
        if(res[0]?.children){
          current[res[0].id] =res[0];
        }
       
        for(let i=0;i<children.length;i++){
          current[children[i].id] = children[i]
        }
        let _docs = prev => children.reduce((acc, item) => {
          let id = '';
          if (item.type === 'catalog' || item.type === 'product') {
            id = item.realId;
          } else {
            id = item.id;
          }
          acc[id] = item;
          return acc;
        }, { ...prev,...current });
        setDocuments({...documents,...current});
      });
      return path;
    }
    const parentId = doc.parents?.[0];
    if (doc.id===root) {
      return path;
    }
    // for (let i = 0; i < firstDocs.length; i++) {
    //   if (firstDocs[i] === doc.id) {
    //     return path;
    //   }
    // }
    return findPath(dispatch, [parentId, ...path], documents);
  };
 
  useEffect(() => {
    if (!tenant?.id) return; 
    setUseLoading(true);

    // console.log("id==============================",id)
    if (id) {
      dispatch(getICatalogDocumentsAction({ tenantId: tenant?.id, id: id }))
      .then((res) => {
        let children = res[0]?.children??res;
        let docs = [];
        for (let i = 0; i < children?.length; i++) {
          docs.push(children[i]?.id);
        }
        if(docs.length==0)
          return;
        if (!documents[id])
          setFirstDocs(docs)
        let current = {};
        if(res[0]?.children){
          current[res[0].id] =res[0];
        }
      
        setDocuments(prev => children?.reduce((acc, item) => {
          let id = '';
          if (item.type === 'catalog' || item.type === 'product') {
            id = item.realId;
          } else {
            id = item.id;
          }

          acc[id] = item;
          return acc;
        }, { ...prev,...current }));
        setUseLoading(false);
      });
    } 
  }, [dispatch, id, documentId, setDocuments, tenant?.id]);


  useEffect(()=>{
    if (documents[id]) {
      setRouters(findPath(dispatch, [id], documents))
    }
  },[documents]) 
  // const handleView = (id) => {
  //   // if (isWarning) {
  //   //   console.log('警告警告');
  //   //   setModeAndData(['warning', []]);
  //   // }
  //   if((!innerUser?.userId&&!user?.id)){
  //     return;
  //   }
  //   if(eventID.length!=0)
  //     return;   
  //   const createID = uuid();
  //   setEventID(createID);
  //   console.log('==========token==-',{id:innerUser?.userId??user?.id,token:innerUser?.token??token})
  //   dispatch(documentEventAction({ 
  //     user:{id:innerUser?.userId??user?.id,token:innerUser?.token??token}, 
  //     tenant:tenant, 
  //     document: { id }, 
  //     type: 'view',
  //     eventId: createID 
  //   }));
  // };
  const handleSendCode = (phone) => {
    return dispatch(sendLoginMobileCodeAction({ mobile: phone }));
  };

  const handleCloseLogin = () => {
    if ((isEmpty(user) || !user)&&documents[id]?.type==='file'&&acl.eoi.includes("view"))
    {
        if(isWeiXin()&&  history.length<=1){
          history.replace('/')
          return 
        }
  
        history.goBack();
      }
    setIsLogining(false);
    // setLoginMode('');
    // setLoginMode('normal');
  };
  // 登录方法
  const handleAuth = async (data) => {
    // ------------------------方法重写----------------------
    // setMode('normal');
    const payload = Object.assign({}, data, pick(user, ['countryCode', 'phone']));
    const res = await dispatch(loginAction(payload)).catch(e => {
      console.error(e);
    });
    dispatch(getTenantsIsLeadsInfoByphoneAction({ tenant, user:res, phone:res.user.phone})).then( res1 => {
      if (documents[id]?.type==='file') {
        setMustShow((!res1.data));
      } else {
        setMustShow((!res1.data) && acl?.eoi?.includes('download'));
      }
    });
    doLogin(res);
    setIsLogining(false);
    if (acl.eoi.includes("download")) {

    }
    return res;
  };
    // 埋点事件
  const sendEvent = (type, document, detail = null,eventID = null) => {

    return SampleSendEvent(dispatch,userShareEvent,type,document,detail,eventID,innerUser?.userId?{id:innerUser?.userId}:user,{id:tenant.id},innerUser?.memberId);
    // let requestDic = {
    //   isCampaign:false, 
    //   user:{user}, 
    //   share:{
    //     id:'11111111-1111-1111-1111-111111111111', 
    //     tenantId:tenant.id ,
    //     tenant
    //   }, 
    //   document, 
    //   type, 
    //   detail 
    // }
    // if(type=='view'&&eventID)
    //   requestDic['eventId'] = eventID;
    // return dispatch(userShareEvent(requestDic));
  };
  useEffect(()=>{
    if (!user  || !id)
      return;
   
    dispatch(getTenantsIsLeadsInfoByphoneAction({ tenant,user:{user,token},phone:user.phone})).then( res => {
      if(documents[id]?.type!='file'){
        return;
      }
      setMustShow((!res.data) && (acl?.eoi?.includes('view')));
    });
    dispatch(getselLeadsInfoByphoneAction({ tenant,user:{user,token},phone:user.phone})).then( res => {
      
      setLeadProfile(res.data?.leads_profile);
    });
 
  },[user,tenant,dispatch,acl,id,documents[id]])
  useEffect(() => { 
    if(documents[id]?.type === 'file' &&getFileType(documents[id]?.asset?.name)==='pdf'){
      // handleView(id)
    }
    
    if (documents[id]?.type !== 'file' && documents[id]?.type !== 'weblink') {
      const data = ((documents[id] ? (documents[id].documents ? documents[id].documents : []) : firstDocs))
      .map(id => documents[id])
      .filter(i => {
        return i;
      })
      .map(doc => ({...doc,
        id: doc.id, 
        name: doc.name, 
        type: doc.type, 
        acl: doc.acl, 
        realId:doc.realId,
        thumbnail: getDocumentThumb(doc), 
        link : `/assets/${root}/${doc.id}?title=${doc.name}`
      }));
      const filterReadableArray = _.filter(data, (o) => {
        const readableList = _.get(o, ['acl', 'readable'], []);
        return readableList.length < 1;
      });
      setData(filterReadableArray);
    }
  },[dispatch, documents, id, firstDocs])
  useEffect(() => {
    if(!documents[id])
      return;
   
    if ((!user)&&acl?.visitor_info?.length>0&&acl?.eoi.includes('view')&&documents[id]?.type==='file') {
      setIsLogining(true);
    }
  },[acl,id,user,documents])
  const handleAuthAndShareEvent = async (data) => {
    const payload = Object.assign({}, data, pick(user, ['countryCode', 'phone']));
    // const process = user.token
    //   ? sendEvent('like', currentDocument, payload)
    //   : dispatch(loginAction(payload))
    //   .then(res => {
    //     onLogin(res);
    //     return res;
    //   });
    // return process.then(
    //   () => { setMode('normal'); setLeadProfile(payload); },
    //   (e) => console.error(e),
    // );
    let res;
    if (token) {
      // if (acl.eoi.includes("view")) {
      //   res = await sendEvent('view', documents[id], payload);
      // }
      await sendEvent('view', documents[id], payload);
      if (acl.eoi.includes("download")) {
        sendEvent('download', documents[id]??selectDoc, payload);
        // window.open(documents[id]?documents[id].asset.url:selectDoc?.asset?.url,"_blank"); 

        DownloadFile(documents[id]?.type==='file'?documents[id].asset.url:selectDoc?.asset?.url,(documents[id]?.type==='file'?documents[id].name:selectDoc?.name)+getFileSuffix(documents[id]?.type==='file'?documents[id].name:selectDoc?.name,documents[id]?.type==='file'?documents[id].asset.name:selectDoc?.asset?.name),window,dispatch) 

      }
                  
    } else {
      res = await dispatch(loginAction(payload));
      doLogin(res);
    }

    setMustShow(false);
    setLeadProfile(payload);
  };
  return (
    <div style={{ 
      width: '100%', 
      height:'calc(100% - 30px)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      {/* <ShareUrl name={documents[id]?.name} show={true} setShow={()=>{}}></ShareUrl> */}
      {deviceType === 'desktop' && <Breadcrumbs 
        style={{
          width: '80%',
          height: '40px',
          padding: '10px 0',
          display: 'flex',
          flexWrap: 'nowrap'
        }} 
        separator=">" 
        maxItems={8}
      >
        <Link color='textPrimary' to={'/'} component={RouteLink}>首页</Link>
        {routers.length == 0 && <Typography color="textPrimary">{params?.title ?? ''}</Typography>}
        {routers.length > 0 && routers.map((item, idx) => {
          console.log('item==', item)
          if (idx === routers.length - 1) {
            return (<Typography key={idx} color="textPrimary">{documents[item]?.name}</Typography>);
          } else {
            return (<Link key={idx} color='textPrimary' to={`/assets/${root}/${documents[item]?.id}?title=${documents[item]?.name}`} component={RouteLink}>
              {documents[item]?.name}
            </Link>);
          }
        })}
      </Breadcrumbs>}

      <Box className={classes.pages} style={{ width: deviceType === 'desktop' ? '80%' : '100%' }}>
        <Box style={{
          width: '100%',
          // paddingTop: deviceType==='desktop' ? '10px' : '0px',
          paddingBottom: deviceType === 'desktop' ? '16px' : '0px',
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}> 
          {/* <Box style={{display:'flex', justifyContent:'space-between'}}>
            {deviceType==='desktop' && <Typography>{params?.title}</Typography>}
          </Box> */}

          <Box style={{
            flexGrow:'1',
            height:'0',
            background:'white',
            padding: documents[id]?.type === 'file' ? '0px' : '20px',
            // marginTop: deviceType === 'desktop' ? '20px' : '0px',
            overflow:'auto'
          }}>
            {(!documents[id] || documents[id]?.type === 'folder') && <Grid container spacing={2} direction="row">
              {data.map((item, idx) => {
                return (<Grid key={`doc-${idx}`} item xs={6} md={4} lg={3}> 
                  <DocumentGridCard 
                  
                     bDownload={true} 
                    document={item} 
                    isWarning={true} 
                    onMenuClick={() => {}} 
                    onClick={(e, id) => { }}
                    onDownloadAction={(doc) => {
                      setSelectDoc(doc);

                      if ((!user)&&acl?.visitor_info?.length>0&&(acl?.eoi.includes('view')||acl?.eoi.includes('download'))) {

                        setIsLogining(true);
                        return ;
                      }
                      if (user) {
                        dispatch(getTenantsIsLeadsInfoByphoneAction({ tenant,user:{user,token},phone:user?.phone})).then( res1 => {
                          if ((!res1.data) && (acl?.eoi?.includes('download')||acl?.eoi?.includes('view'))) {
                            setMustShow((!res1.data) && (acl?.eoi?.includes('download')||acl?.eoi?.includes('view')));
                            return;
                          }
                          sendEvent('download', doc);
                          // dispatch(userShareEvent({user:{user:user}, share:{tenantId:tenant.id, id:'11111111-1111-1111-1111-111111111111'}, document:doc, type:'download', detail:null}));

                          DownloadFile(doc.asset.url,doc.name+getFileSuffix(doc.name,doc?.asset?.name),window,dispatch) 
                          return;
                          // window.open(doc.asset.url,"_blank"); 
                        });
                      }
                      if (!user&&!acl?.eoi?.includes('download')) {
                        // dispatch(userShareEvent({user:{user:user}, share:{tenantId:tenant.id, id:'11111111-1111-1111-1111-111111111111'}, document:doc, type:'download', detail:null}));
                        sendEvent('download', doc);

                        DownloadFile(doc.asset.url,doc.name+getFileSuffix(doc.name,doc?.asset?.name),window,dispatch) 

                        // window.open(doc.asset.url, "_blank"); 
                      }
                    }} 
                  />
                </Grid>)
              })}
            </Grid>}

            {documents[id]?.type === 'file' && <Box style={{ backgroundColor:'#e5e5e', height:'100%' }}>
              <FileDocument 
              setEventID={setEventID}
              sendEvent={sendEvent}
              eventID={eventID}
                handleDownload={(document) => { 
                  if ((!user)&&acl?.visitor_info?.length>0&&(acl?.eoi.includes('view')||acl?.eoi.includes('download'))) {
                    setIsLogining(true);
                    return;
                  }
                  dispatch(getTenantsIsLeadsInfoByphoneAction({ tenant, user:{user, token}, phone:user?.phone})).then( res => {
                   
                    setMustShow((!res.data) && (acl?.eoi?.includes('download')||acl?.eoi?.includes('view')));
                    if (!((!res.data) && (acl?.eoi?.includes('download')||acl?.eoi?.includes('view')))) {
                      //window.open(document.asset.url, "_blank");
                      sendEvent('download', document);

                      // dispatch(userShareEvent({
                      //   user:user, 
                      //   share:{
                      //     tenantId:tenant.id,
                      //     id:'11111111-1111-1111-1111-111111111111',
                      //     // memberId:innerUser?.memberId
                      //   }, 
                      //   document, 
                      //   type:'download', 
                      //   detail:null
                      // }));
                      DownloadFile(document?.asset?.url,document?.name+getFileSuffix(document.name,document?.asset?.name),window,dispatch) 

                    }
                  });
                }} 
                document={documents[id]}
                user={{user,token}} 
                share={null}
                onClose={()=>{ history.goBack()}}
                onLikeFormOpen={()=>{}}
                tenant={tenant}
              />
            </Box>}

                  {/* 登录弹框 */}
      {isLogining&&<Dialog
        open={isLogining}
        maxWidth='xs'
        // onClose={handleCloseForm}
      >
        <LoginForm 
          user={user} 
          doSendCode={handleSendCode}
          share={{tenant}}
          onSubmit={handleAuth}
          onClose={handleCloseLogin}
        />
      </Dialog>}
      { !isEmpty(user) && !isNull(user) && mustShow && 
          <Dialog
            open={acl?.visitor_info?.length>0&&mustShow}
            maxWidth='xs'
          // onClose={handleCloseForm}
          >
            <LeadMustForm
              share={{tenant:{...tenant, info:{industries:tenant?.tnt_info?.industries}}, required:acl?.required}}
              user={user}
              visitorInfo={acl?.visitor_info ?? []}
              leadProfile={leadProfile}
              doSendCode={handleSendCode}
              onSubmit={handleAuthAndShareEvent}
              onClose={()=>{setMustShow(false)
                if (acl?.eoi?.includes('view')&&documents[id]?.type==='file') {
                  history.goBack();
                }

              }}
            />
          </Dialog>
      }
      {/*  */}
          </Box>

        </Box>
      </Box>
    </div>
  );
};

function FileDocument(props: any) {
  const { document, onClose, onLikeFormOpen, share, user, tenant, handleDownload,eventID ,sendEvent,setEventID} = props;
  const { asset } = document;
  const dispatch = useDispatch();
  // file type
  const isFile = document.type === 'file';
  const fileType = isFile && getFileType(document.name);

  const isPreview = false;
  
  const onLeft = (e) => {

  };
  useEffect(() => {
    if (!document)
      return;
    console.log("user--------------------------",user)
      // 内部用户？才走这个埋点
      // 前端生成一个uuid  eventId： uuid 传递给后台
      // setEventID(createID);
      // -------------end--------------------------
      let createID = null
      if(document.type==='file'&&getFileType(document?.asset?.name??' ')=='pdf'){
        createID= uuid()
        setEventID(createID)
      }
      sendEvent('view', document,null,createID);

  }, []);

  
  const onRight = () => {
    const anchor = window.document.createElement('a');
    const body = window.document.querySelector('body');
    anchor.href = asset.url;
    anchor.download = document.name;
    anchor.style.display = 'none';
    body.appendChild(anchor);
    anchor.click();
    body.removeChild(anchor); 
    window.URL.revokeObjectURL(anchor.href);
  };
  return (
    <Box style={{backgroundColor: '#2F3941', height:'100%'}}>
      <PreviewDialog 
        eventID={eventID}
        handleDownload={handleDownload}
        document={document} 
        onClose={onClose} 
        isPreview={isPreview} 
        user={user} 
        tenant={tenant}
        share={share} 
        onLikeFormOpen={onLikeFormOpen} 
        type='share' 
      />
      {/* <Toolbar /> */}
      {fileType !== 'pdf' &&  <Toolbar /> }
      {/* {fileType !== 'pdf' && <Toolbar 
        style={{
          position: 'fixed',  bottom: 0,
          width: '100%',
          display: 'flex', justifyContent: 'center'
        }}>
        <Button variant='contained'
          style={{ borderRadius: '16px', backgroundColor: '#39AC4A', color: 'white' }}
          onClick={onLikeFormOpen}
        >
          我感兴趣，请联系我
        </Button>

      </Toolbar>} */}
    </Box>
  );
}

export default function FileDownloadContainer (props) {

  return (
    <FileDownloadView {...props}/>
  );
}

